<template>
  <div>
    <el-checkbox v-if="!noSelectAll" v-model="allChecked" class="mb-20 d-block">
      Выбрать все
    </el-checkbox>
    <el-checkbox-group :value="checked" @input="emitUpdate">
      <el-checkbox
        v-for="item in list"
        :key="item.id"
        :indeterminate="indeterminates.includes(item.id)"
        class="mb-12 d-block"
        :label="item.id">
        <slot :item="item">{{ item.name }}</slot>
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
  export default {
    props: {
      list: Array,
      checked: Array,
      noSelectAll: {
        type: Boolean,
        default: false
      },
      indeterminates: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      allChecked: {
        get() {
          return this.list.length === this.checked.length
        },
        set(val) {
          if (val) {
            this.emitUpdate(this.list.map(item => item.id))
          } else {
            this.emitUpdate([])
          }
        }
      }
    },

    methods: {
      emitUpdate(value) {
        this.$emit('update:checked', value)
      }
    }
  }
</script>